import React from 'react';
import {connect} from "react-redux";
import Renderers from "../../helpers/Renderers";
import {RxForm, FormManager, FormField, FormRow, Multiform} from 'reactis-forms';
import {bindActionCreators} from 'redux';
import * as tabActions from "../../redux/modules/tabs";

class DriverSubform extends React.Component {

	static contextTypes= {
		router: React.PropTypes.object
	};

	constructor(props) {
		super(props);
		this.state = {
			overRemove: false
		}
	}

	handleMouseOver() {
		this.setState({overRemove: true});
	}

	handleMouseOut() {
		this.setState({overRemove: false});
	}

	handleOpen(e, row) {
		e.preventDefault();
		this.props.actions.openTabForm('driver', row.surname + ' ' + row.name, {id: row.driver});
		//this.context.router.replace('/driver/'+row.driver);
	}

	handleCreateTr() {
		this.props.parentProps.onCreateTraining(this.props.state.getIn(['values', 'driver']));
	}

	render() {
		const values = this.props.state.get('values').toJS();
		const re = values.trainingtype && this.props.parentProps.trainingTypes.filter((item) => item.id == values.trainingtype)[0].re === 1;
		return (
			<tr className={this.state.overRemove ? 'subformOverRemove' : null}>
				<td className="name">{values.ev}</td>
				<td className="name">{values.surname}</td>
				<td className="name">{values.name}</td>
				<td className=""><FormField name="trainingtype" /></td>
				<td className=""><FormField name="price" /></td>
				{!re &&
				<td className="">
					{!re && <FormField name="groups1" />}

				</td>}
				{!re &&
				<td className="">
					{!re && <FormField name="groups2" />}
				</td>}
				{re &&
				<td className="" colSpan={2}>
					{re && <i>opakované školení bere skupiny z karty řidiče</i>}
				</td>}
				<td className="" style={{textAlign:'center'}}>
					{this.props.parentProps.showCreateTraining && <div>
						{values.trainingEv && values.trainingEv}
						{!values.trainingEv && <div className="btn-sm btn btn-success" onClick={(e) => this.handleCreateTr()}>+ založit</div>}
					</div>}
				</td>
				<td><i title="Odstranit"
				       onClick={this.props.onRemove}
				       onMouseOver={() => this.handleMouseOver()}
				       onMouseOut={() => this.handleMouseOut()}
				       className="icon-cross removesubform"/>
				</td>
			</tr>
		)
	}
}

export default connect(null, (dispatch) => {
		return {actions: bindActionCreators(tabActions, dispatch)};
	})(DriverSubform);


// WEBPACK FOOTER //
// ./src/containers/Order/DriverSubform.js